export default __webpack_public_path__ + "89deb673657dcccbae535c4404b57c6d.jpg";